// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__2m4vf","head":"ProcedureTableInfo_head__19SPP"};